import { DEFAULT_ENTITY_AUTHOR } from 'domain/shared/core/constants';
import { EntityHeader } from 'framework/ui/layout';

const ServiceCostsStructureEntityHeader = () => {
  return <EntityHeader entityTitleSource="name" defaultAuthor={DEFAULT_ENTITY_AUTHOR} />;
};

export default ServiceCostsStructureEntityHeader;
